export const ERROR_MAP: Record<string | number, string> = {
    101: 'Campo requerido faltante en la petición',
    105: 'Valor inválido en campo',
    1055: 'Problema de conexión con API SMART',
    1: 'Token no válido',
    2: 'Valor de campo no válido',
    3: 'RIF no corresponde al token',
    4: 'Impuesto mal calculado',
    5: 'Campo requerido ausente',
};
